<template>
  <div id="app">
    <!-- 轮播图部分 -->
    <div class="carousel-container">
      <div class="carousel">
        <div class="carousel-slide">
          <img :src="currentImage" alt="轮播图" class="carousel-image">
          <div class="carousel-overlay">
            <h1 class="carousel-text">一脉相承</h1>
          </div>
        </div>
      </div>
      <!-- 轮播指示器 -->
      <div class="carousel-indicators">
        <span 
          v-for="(image, index) in images" 
          :key="index" 
          :class="{ active: currentIndex === index }"
          @click="goToSlide(index)"
        ></span>
      </div>
    </div>

    <!-- 下载APP部分 -->
    <div class="download-section">
      <a href="https://amtb.top/app/app-release.apk" class="download-btn">
        下载APP
      </a>
    </div>
  </div>
</template>

<script>
import slide1 from './assets/slide1.jpg'
import slide2 from './assets/slide2.jpg'
import slide3 from './assets/slide3.jpg'

export default {
  name: 'App',
  data() {
    return {
      images: [
        slide1,
        slide2,
        slide3
      ],
      currentIndex: 0,
      timer: null
    }
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    }
  },
  mounted() {
    this.startCarousel();
  },
  beforeUnmount() {
    this.stopCarousel();
  },
  methods: {
    startCarousel() {
      this.timer = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    stopCarousel() {
      clearInterval(this.timer);
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    goToSlide(index) {
      this.currentIndex = index;
      this.stopCarousel();
      this.startCarousel();
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.carousel-container {
  position: relative;
  width: 100%;
  height: 60vh;
  min-height: 400px;
  overflow: hidden;
}

.carousel-slide {
  width: 100%;
  height: 100%;
  position: relative;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* 使用渐变而不是纯色背景，底部透明度更高，保留更多图片细节 */
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.4) 40%,
    rgba(0, 0, 0, 0.1) 100%
  );
  display: flex;
  justify-content: center;
  align-items: center;
  /* 添加轻微的模糊效果，增强文字可读性 */
  backdrop-filter: blur(1px);
}

.carousel-text {
  color: white;
  font-size: 4rem;
  font-weight: bold;
  /* 增强文字阴影，提高对比度 */
  text-shadow: 
    0 0 10px rgba(0, 0, 0, 0.8),
    0 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 0.3rem;
  /* 添加轻微的外发光效果 */
  filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.3));
  /* 确保文字始终在图片上层 */
  z-index: 10;
  /* 文字边框，提高可读性 */
  -webkit-text-stroke: 1px rgba(0, 0, 0, 0.3);
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.carousel-indicators span {
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background-color 0.3s;
}

.carousel-indicators span.active {
  background-color: white;
}

.download-section {
  width: 100%;
  padding: 60px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.download-btn {
  background-color: #2196F3;
  color: white;
  padding: 20px 40px;
  border-radius: 8px;
  text-decoration: none;
  font-size: 1.2rem;
  font-weight: bold;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.download-btn:hover {
  background-color: #0d8aee;
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .carousel-text {
    font-size: 2.8rem;
    letter-spacing: 0.2rem;
  }
  
  .download-btn {
    padding: 15px 30px;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .carousel-text {
    font-size: 2rem;
    letter-spacing: 0.1rem;
  }
}
</style>
